export { default } from './TableSortLabel';


//////////////////
// WEBPACK FOOTER
// ../~/@material-ui/core/esm/TableSortLabel/index.js
// module id = 601
// module chunks = 121